import { SocialAuthService } from '@abacritt/angularx-social-login';
import { Component, Input } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { AuthService } from '../services/auth-service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  @Input() sidenav!: MatSidenav;
  user: any;
  userEmailId: any;

  constructor(private storage: LocalStorageService,
    public router: Router,
    private authService: AuthService,
    private socialAuthService: SocialAuthService) {
    this.userEmailId = this.storage.retrieve("userEmailId");
    this.user = this.storage.retrieve("user");
  }

  logOut(): void {
    let isLoggendIn: boolean = this.authService.checkAuthState();
    if (isLoggendIn) {
      this.socialAuthService.signOut();
    }
    this.storage.clear();
    this.sidenav.close();
    this.router.navigate(['/login']);
  }
}
